<template>
	<div>
		<!-- 带输入框的行 布局-->
		<div class="hang" :style="{borderBottom:isShowxian? '1px solid #8F8F94':''}" v-if="listtype == '1'">
			<div class="hang-left">
				{{title}}
				<i class="iconfont iconbitian" v-if="isRequired"></i>  <!-- 必填图标 -->
			</div>
			<div class="hang-right">
				<input v-model="value" :placeholder="placeholder" :type="type"  @input="inputevent" class="input"/>
				<div class="icon">
					<i class="iconfont" :class="iconName" style="color: #8F8F94;"></i>  <!-- 传入的图标，默认向右-->
				</div>
			</div>
		</div>
		
		<!-- 标题 和图标 靠两边 -->
		<div class="buju"  v-if="listtype == '2'">
			<div>
				{{title}}
			</div>
			<div @click="bianji">
				<i class="iconfont" :class="iconName" v-if="isIcon"></i>
			</div>
		</div>
		<!-- 两个 文字占50%宽 -->
		<div class="buju" v-if="listtype == '3'">
			<div :style="{width:'50%',display:'flex','justify-content':justifyContent,'align-items': alignItems}">
				{{title}}
			</div>
			<div :style="{width:'50%',display:'flex','justify-content':justifyContent,'align-items': alignItems}">
				{{titletwo}}
			</div>
		</div>
	</div>
</template>

<script>
    export default{
        props:{
            // 标题
            title:{
                type:String,
                default:'sss'
            },
            // 输入框的值
            value:{
                type:String|Number,
                default:''
            },
            // 图标名称
            iconName:{
                type:String,
                default:'iconxiangyou'
            },
            
            // 是否必填
            isRequired:{
                type:Boolean,
                default:false
            },
            // 输入提示
            placeholder:{
                type:String,
                default:'请输入内容'
            },
            // 是否显示输入框行  底部的线
            isShowxian:{
                type:Boolean,
                default:false
            },
            // 输入框的类型
            type:{
                type:String,
                default:'text'
            },
            // 列的类型 listtype 
            // 1:输入框 2:左右 3：分半左右
            listtype:{
                type:String,
                default:'1'
            },
            
            // 是否显示图标
            isIcon:{
                type:Boolean,
                default:false
            },
            // 标题2
            titletwo:{
                type:String,
                default:''
            },
            
            // 样式布局 横向居中|靠左|靠右
            justifyContent:{
                type:String,
                default:' flex-start'
            },
            // 样式布局 竖向 居中|靠上|靠下
            alignItems:{
                type:String,
                default:' flex-start'
            }
        },
        data(){
            return{
                
            }
        },
        methods:{
            // 输入框
            inputevent(e){
                this.$emit('input',e.detail.value)
            },
            // 编辑
            bianji(){
            this.$emit('bianji')
            }
        }
    }
</script>

<style lang="scss" scoped>
	.hang{
		display: flex;
		flex-direction: row;
		height: 70px;
		padding: 0 10px;
	}
	.hang-left{
		width: 15%;
		height: 70px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		.iconbitian{
			color: red;
		}
	}
	.hang-right{
		width: 85%;
		height: 70px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		.input{
			width: 90%;
			height: 70px;
			outline: none;
			border: 0px;
		}
		.icon{
			width: 70px;
			height: 70px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			
		}
	}
	.buju{
		 width: 100%;
		 display: flex;
		 flex-direction: row;
		 justify-content: space-between;
		 align-items: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/gongju/Row-nca.vue